import React, { useState } from "react";
import ZDrawer from "@molecules/ZDrawer";
import {
	Product,
	BundleProduct,
	ProductType,
	ProductPricingPlan
} from "@/Contracts/Products";
import SearchDocumentProductCatalog from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/SearchDocumentProductCatalogDrawer/SearchDocumentProductCatalog";
import EditBundleChildProductDrawer from "../Edit";
import ZMessage from "@molecules/ZMessage";
import { IAddBundleChildToProductDrawerProps } from "./interface";

const AddBundleChildToProductDrawer: React.FC<
	IAddBundleChildToProductDrawerProps
> = props => {
	const [selectedQuoteProduct, setSelectedQuoteProduct] =
		useState<BundleProduct | null>(null);

	const [pricing, setPricing] = useState<ProductPricingPlan>();

	const handleSubmit = (
		selectedProducts: Product[],
		productVsPricing: Record<string, string | null>
	) => {
		try {
			const selectedProduct = selectedProducts[0];
			if (selectedProduct.type === ProductType.Bundle) {
				ZMessage.error("You cannot add a bundle to another bundle");
				return;
			}
			const selectedPricing = selectedProduct.pricing?.find(
				p => p.id === productVsPricing[selectedProduct.id]
			);
			setPricing(selectedPricing);
			const childProductRequest: BundleProduct = {
				item_id: selectedProduct.id,
				item: selectedProduct,
				quantity: 1,
				selected_pricing_id: selectedPricing?.id,
				selected_setup_price: selectedPricing?.setup_price,
				selected_cost_price: selectedPricing?.cost_price,
				selected_billing_period: selectedPricing?.billing_period,
				is_optional: false,
				is_selected: false,
				sell_price: selectedPricing?.sell_price,
				tax_category_id: selectedProduct.tax_category_id,
				custom_fields: selectedProduct.custom_fields,
				mandatory_custom_field_check_require: true
			};
			setSelectedQuoteProduct(childProductRequest);
		} catch (error) {
			console.error(error);
		}
	};

	const handleConfigureDrawerClose = () => setSelectedQuoteProduct(null);

	const handleConfigureProductSubmit = async (
		quoteProduct: BundleProduct
	) => {
		setSelectedQuoteProduct(null);
		if (props.onClose) {
			props.onClose();
		}
		props.onSubmit(quoteProduct);
	};

	const isConfigureDrawerVisible = !!selectedQuoteProduct;

	return (
		<ZDrawer
			visible={props.visible}
			closable={true}
			destroyOnClose={true}
			onClose={props.onClose}
			title="Search Product"
			className="search-document-product-drawer zomentum-drawer"
			removeDefaultPadding
		>
			<SearchDocumentProductCatalog
				isLoading={false}
				onClose={props.onClose}
				onSubmit={handleSubmit}
				itemType={"bundle"}
				isFromProductsPage={props.isFromProductsPage}
			/>

			{selectedQuoteProduct && (
				<EditBundleChildProductDrawer
					currentActiveProduct={selectedQuoteProduct}
					onClose={handleConfigureDrawerClose}
					onSubmit={handleConfigureProductSubmit}
					visible={isConfigureDrawerVisible}
					currentActiveDocument={props.currentActiveDocument}
					bundledProductList={props.bundledProductList}
					isFromAddDrawer
					pricing={pricing}
					supplierId={props.supplierId}
				/>
			)}
		</ZDrawer>
	);
};

export default AddBundleChildToProductDrawer;
